import { UserDetails } from '@robocorp/robocloud-internal-cds-sdk';

export const getUserNameFromDetails = (details: UserDetails | undefined): string => {
  if (!details) {
    return '';
  }
  if (details.first_name && details.last_name) {
    return `${details.first_name} ${details.last_name}`;
  }
  if (details.nickname) {
    return details.nickname;
  }
  if (details.email) {
    return details.email.split('@')[0];
  }
  return '';
};
